<template>
  <div class="Warp">
    <van-notice-bar color="#1989fa" background="#ecf9ff">
      企业详情
    </van-notice-bar>
    <van-cell-group>
      <van-cell title="企业名称" :value="detail.company_full_name" />
      <van-cell>
        <template #title>
          <span class="custom-title">企业logo</span>
          <van-image
            width="2rem"
            height="2rem"
            :src="$store.state.imgUrl+detail.company_logo"
            style="float:right"
            @click="clickImg"
          />
        </template>
      </van-cell>
      <van-cell title="管理员手机号" :value="detail.mobile" />
      <van-cell title="企业地址" :value="detail.company_address" />
      <van-cell title="企业简介" :label="detail.company_detail" />
      <van-cell title="联系人姓名" :value="detail.principal_name" />
      <van-cell title="联系人手机号" :value="detail.principal_tel" />
      <van-cell
        title="企业状态"
        :value="detail.company_status == 1 ? '已开通' : '审核中'"
      />
      <van-cell title="创建时间" :value="detail.create_time" />
    </van-cell-group>
  </div>
</template>
<script>
export default {
  data() {
    return {
      detail: {},
    };
  },
  mounted() {
    this.getDetail();
  },
  methods: {
    getDetail() {
      this.detail = this.$route.query;
      console.log(this.detail);
    },
    clickImg(e){
        console.log(e);
    }
  },
};
</script>
<style lang="less" scoped>
 .custom-title {
    // margin-right: 10px;
    vertical-align: top;
  }
</style>